// Catalogo do perfil publico: modelos, secoes e opcoes de estilo.
// Os ids batem com o contrato da API (TemplateId, SectionId, ThemeSettings).

export const PRO_COLOR = "#6554C0";
export const DEFAULT_COMPANY_COLOR = "#1551b1";

export const TEMPLATES = [
  {
    id: "classic",
    // Segue a ordem das seções do editor? Nos outros, cada bloco tem lugar fixo no layout.
    reorderable: true,
    name: "Clássico",
    short: "Currículo organizado, bom para PDF",
    description: "Currículo organizado, o melhor para virar PDF.",
    tags: ["Bom para PDF"],
  },
  {
    id: "minimal",
    reorderable: true,
    name: "Minimalista",
    short: "Só texto, muito respiro",
    description: "Só texto e muito respiro. Para quem quer ir direto ao ponto.",
    tags: ["Leve"],
  },
  {
    id: "card",
    reorderable: false,
    name: "Cartão",
    short: "Links grandes, feito para celular",
    description: "Botões grandes. Feito para mandar pelo WhatsApp.",
    tags: ["Feito para celular"],
  },
  {
    id: "modern",
    reorderable: false,
    name: "Moderno",
    short: "Faixa colorida, serve para qualquer área",
    description: "Faixa na sua cor, foto em destaque e duas colunas. Serve para qualquer área.",
    tags: ["Qualquer área"],
  },
  {
    id: "timeline",
    reorderable: false,
    name: "Trajetória",
    short: "Sua carreira numa linha do tempo",
    description: "Sua carreira numa linha do tempo: experiências e formação na ordem em que aconteceram.",
    tags: ["Qualquer área"],
  },
  {
    id: "sidebar",
    reorderable: false,
    name: "Coluna fixa",
    short: "Escuro, nome sempre à vista",
    description: "Fundo escuro com seu nome sempre à vista.",
    tags: ["Tem vídeo"],
  },
  {
    id: "bento",
    reorderable: false,
    name: "Mosaico",
    short: "Blocos com foto e vídeo",
    description: "Blocos com foto, vídeo, idiomas e seu perfil comportamental.",
    tags: ["Tem vídeo", "Recrutest"],
  },
  {
    id: "editorial",
    reorderable: false,
    name: "Editorial",
    short: "Tipografia grande, com personalidade",
    description: "Tipografia grande e muita personalidade.",
    tags: ["Tem vídeo"],
  },
  {
    id: "terminal",
    reorderable: true,
    name: "Terminal",
    short: "Para Tech: escuro, fonte mono",
    description: "Pensado para Tech: fundo escuro, fonte mono e cada seção como um comando.",
    tags: ["Tech"],
  },
  {
    id: "law",
    reorderable: true,
    name: "Jurídico",
    short: "Para Direito: sóbrio, com serifa",
    description: "Pensado para Direito: folha sóbria, serifa e seções numeradas.",
    tags: ["Direito"],
  },
  {
    id: "finance",
    reorderable: false,
    name: "Finanças",
    short: "Indicadores e trajetória em tabela",
    description: "Pensado para Finanças: indicadores no topo e trajetória em tabela.",
    tags: ["Finanças"],
  },
  {
    id: "gamer",
    reorderable: false,
    name: "Gamer",
    short: "O perfil vira um jogo",
    description: "O perfil vira um jogo: PRESS START, menu, missões, inventário e conquistas. Para Tech que foge à regra.",
    tags: ["Gamer"],
  },
  {
    id: "platformer",
    reorderable: false,
    name: "Plataforma",
    short: "Uma fase de jogo 2D sobre você",
    description: "Uma fase de jogo 2D: o personagem anda com as setas pelas áreas que apresentam você.",
    tags: ["Gamer"],
  },
  {
    id: "animated",
    reorderable: false,
    name: "Animado",
    short: "Apresentação que roda sozinha",
    description: "Uma apresentação que roda sozinha, como um vídeo, e no fim vira o perfil completo.",
    tags: ["Animado"],
  },
];

// Fallback caso a API ainda nao mande `pro`.
// Personagens do modelo Plataforma (sprites em recrutei-profile-front/public/platformer).
export const PLATFORMER_CHARACTERS = [
  { id: "w1", label: "Mulher, pele clara, cabelo loiro" },
  { id: "w2", label: "Mulher negra, cabelo black" },
  { id: "w3", label: "Mulher parda, cabelo castanho" },
  { id: "w4", label: "Mulher asiática, cabelo preto" },
  { id: "w5", label: "Mulher negra, tranças" },
  { id: "w6", label: "Mulher indígena, cabelo liso" },
  { id: "w7", label: "Mulher gordinha, cabelo preto curto" },
  { id: "w8", label: "Mulher magra, cabelo preto longo" },
  { id: "w9", label: "Mulher mais velha, grisalha" },
  { id: "w10", label: "Mulher ruiva, sardas" },
  { id: "w11", label: "Mulher negra gordinha, cabelo curto" },
  { id: "m1", label: "Homem, pele clara, cabelo castanho" },
  { id: "m2", label: "Homem negro, barba" },
  { id: "m3", label: "Homem pardo, cabelo cacheado" },
  { id: "m4", label: "Homem asiático, cabelo preto" },
  { id: "m5", label: "Homem grisalho, de óculos" },
  { id: "m6", label: "Homem pardo, careca e barba" },
  { id: "m7", label: "Homem negro, dreads" },
  { id: "m8", label: "Homem mais velho, bigode branco" },
  { id: "m9", label: "Homem indígena" },
];

// Animado: fundos e ritmos da apresentacao. O "swatch" e so a miniatura do editor.
export const PRESENTATION_BACKDROPS = [
  { id: "night", label: "Noite", swatch: "radial-gradient(circle at 30% 30%, #6554c0 0, transparent 60%), #06152b" },
  { id: "accent", label: "Na cor do perfil", swatch: "linear-gradient(135deg, var(--pp-color), #06152b)" },
  { id: "sunset", label: "Pôr do sol", swatch: "linear-gradient(165deg, #06152b, #6554c0 48%, #de2348 82%, #ff5900)" },
  { id: "aurora", label: "Aurora", swatch: "radial-gradient(circle at 25% 30%, #6554c0, transparent 55%), radial-gradient(circle at 75% 30%, #309e3a, transparent 50%), radial-gradient(circle at 50% 85%, #4169e1, transparent 55%), #06152b" },
  { id: "grid", label: "Grade", swatch: "repeating-linear-gradient(0deg, #6554c0 0 1px, transparent 1px 8px), repeating-linear-gradient(90deg, #6554c0 0 1px, transparent 1px 8px), #06152b" },
  { id: "photo", label: "Sua foto", swatch: "linear-gradient(135deg, #4f4f4f, #06152b)" },
];

export const PRESENTATION_PACES = [
  { id: "calm", label: "Calmo" },
  { id: "normal", label: "Normal" },
  { id: "quick", label: "Rápido" },
];

export const DEFAULT_PRO_TEMPLATES = ["sidebar", "bento", "editorial", "terminal", "law", "finance", "gamer", "platformer", "animated"];
export const DEFAULT_PRO_SECTIONS = ["video", "audio", "links"];

export const SECTIONS = {
  about: { label: "Sobre", icon: "FileTextIcon" },
  experience: { label: "Experiências", icon: "BriefcaseIcon" },
  education: { label: "Formação", icon: "BookOpenIcon" },
  languages: { label: "Idiomas", icon: "GlobeIcon" },
  skills: { label: "Habilidades", icon: "ToolIcon" },
  behavioral: { label: "Perfil comportamental", icon: "AwardIcon" },
  video: { label: "Vídeo de apresentação", icon: "VideoIcon" },
  audio: { label: "Áudio de apresentação", icon: "MicIcon" },
  availability: { label: "Como prefiro trabalhar", icon: "HomeIcon" },
  links: { label: "Links", icon: "LinkIcon" },
  contact: { label: "Botão de contato", icon: "MailIcon" },
};

export const DEFAULT_SECTION_ORDER = [
  "about",
  "experience",
  "education",
  "languages",
  "skills",
  "behavioral",
  "video",
  "audio",
  "availability",
  "links",
  "contact",
];

export const ACCENT_COLORS = [
  "#4169E1",
  "#309E3A",
  "#06152B",
  "#6554C0",
  "#FF5900",
  "#DE2348",
];

export const FONTS = [
  { id: "sans", label: "Roboto", family: "'Roboto', sans-serif" },
  { id: "serif", label: "Roboto Serif", family: "'Roboto Serif', serif" },
  { id: "mono", label: "Roboto Mono", family: "'Roboto Mono', monospace" },
];

export const PHOTO_SHAPES = [
  { id: "round", label: "Redonda" },
  { id: "square", label: "Quadrada" },
  { id: "none", label: "Sem foto" },
];

export const BUTTON_SHAPES = [
  { id: "pill", label: "Pílula", radius: "9999px" },
  { id: "rounded", label: "Arredondado", radius: "6px" },
  { id: "square", label: "Reto", radius: "0" },
];

export const DEFAULT_THEME = {
  accent: null,
  font: "sans",
  photoShape: "round",
  buttonShape: "rounded",
};

export function templateById(id) {
  return TEMPLATES.find((t) => t.id === id) || TEMPLATES[0];
}

// 990 -> "R$ 9,90"
export function formatCents(cents) {
  const value = Number(cents || 0) / 100;
  try {
    return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  } catch (e) {
    return `R$ ${value.toFixed(2).replace(".", ",")}`;
  }
}

export function formatDate(iso) {
  if (!iso) return "";
  const date = new Date(iso);
  if (isNaN(date.getTime())) return "";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${date.getFullYear()}`;
}

export function displayUrl(url) {
  return String(url || "").replace(/^https?:\/\//, "").replace(/\/+$/, "");
}

export function plural(count, singular, pluralForm) {
  return `${count} ${count === 1 ? singular : pluralForm}`;
}

export function isMobileWidth() {
  return typeof window !== "undefined" && window.innerWidth < 768;
}

// Copia com a Clipboard API e cai para execCommand em navegador antigo ou
// contexto sem permissao (iframe, http).
export async function copyText(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (e) {
    // segue para o fallback
  }
  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch (e) {
    return false;
  }
}

// Endereco escolhido no PRO (recrutei.me/{nome}): mesma regra da API, com no maximo 40 letras.
export const SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{1,38}[a-z0-9])$/;

export function slugify(text) {
  return String(text || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-+/, "");
}
